import { render, staticRenderFns } from "./AccessorialsGroupList.vue?vue&type=template&id=2dcca2d0&scoped=true"
import script from "./AccessorialsGroupList.vue?vue&type=script&lang=js"
export * from "./AccessorialsGroupList.vue?vue&type=script&lang=js"
import style0 from "./AccessorialsGroupList.vue?vue&type=style&index=0&id=2dcca2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcca2d0",
  null
  
)

export default component.exports